import { Settings } from 'react-slick';
import { getAsset } from 'src/utils';

export const settings: Settings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: false,
  pauseOnHover: true,
  waitForAnimate: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const getItems = (t?: any) => [
  {
    src: getAsset('arrows.svg'),
    label: t?.tips_arrows || 'Use keyboard arrows or WASD keys to move',
  },
  {
    src: getAsset('mouse.svg'),
    label: t?.tips_mouse || 'Click and Drag to look around',
  },
  {
    src: getAsset('headphones.svg'),
    label: t?.tips_headphones || 'Turn sound on (in settings)',
  },
  {
    src: getAsset('touch.svg'),
    label: t?.tips_touch || 'Use mouse/touchscreen to interact with objects',
  },
  {
    src: getAsset('responsive.svg'),
    label: t?.tips_responsive || 'Tablet and mobile friendly',
  },
  {
    src: getAsset('wifi.svg'),
    label: t?.tips_wifi || '~2mbit internet requierd for the best experience',
  },
  {
    src: getAsset('latest-version.svg'),
    label:
      t?.tips_latestVersions ||
      'Use the latest device and browser versions to ensure smooth operation of the tours',
  },
];
